import React from "react";
import retry from '~/assets/images/retry-capture.svg';

interface CaptureTypeDialogProps {
  retryAutocapture: () => void;
  switchToManual: () => void;
  exitDialog: () => void;
}

const CaptureTypeDialog = ({ retryAutocapture, switchToManual, exitDialog }: CaptureTypeDialogProps) => {

  return <React.Fragment>
    <div className="capture-type-dialog-wrapper">
      <button id="closeDialogBtn" onClick={exitDialog}>
        <i className="fas fa-times"></i>
      </button>
      <div className="capture-type-dialog-content">
        <div className="justify-content-center d-flex">
          <img src={retry} className="mx-2" />
        </div>
        <div className="mt-3 mb-3 info text-center"><strong>Autocapture failed to produce a viable image.</strong></div>
        <div className="mb-3 info text-center">
          Do you want to:
        </div>
        <div className="mt-4 px-4">
          <button className="btn btn-primary submit-btn-mobile w-100 mb-2" onClick={retryAutocapture}>Retry autocapture</button>
          <button className="btn btn-primary submit-btn-mobile w-100" onClick={switchToManual}>Switch to manual capture</button>
        </div>
      </div>
    </div>
  </React.Fragment>
}

export default CaptureTypeDialog;
